import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import { fetchAuthSession } from "aws-amplify/auth";
import { AtomicLogo } from "../../../assets/AtomicLogo";

export const AuthCallbackComponent = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Wait for Amplify to process the OAuth callback
        // This will automatically complete the authentication flow
        await fetchAuthSession({ forceRefresh: true });

        // Small delay to ensure the auth state is fully updated
        setTimeout(() => {
          navigate("/", { replace: true });
        }, 1000);
      } catch (err: any) {
        console.error("OAuth callback error:", err);
        setError("Authentication failed. Redirecting to sign in...");

        // Redirect to sign in after a delay
        setTimeout(() => {
          navigate("/", { replace: true });
        }, 3000);
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "#fafafa",
        padding: 2,
      }}
    >
      <Box sx={{ mb: 3 }}>
        <AtomicLogo width={80} height={80} />
      </Box>

      <CircularProgress
        size={60}
        sx={{
          color: "#3877F7",
          mb: 2,
        }}
      />

      <Typography
        variant="h6"
        sx={{
          color: "#333333",
          fontWeight: 300,
          textAlign: "center",
        }}
      >
        {error ? error : "Completing authentication..."}
      </Typography>

      {error && (
        <Typography
          variant="body2"
          sx={{
            color: "#666666",
            textAlign: "center",
            mt: 1,
          }}
        >
          Please wait while we redirect you.
        </Typography>
      )}
    </Box>
  );
};
